import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';
import {
FLAG_GETTING_EXCHANGE_RATES,
  GET_EXCHANGE_RATES,
  CLEAR_EXCHANGE_RATES,
  FLAG_GETTING_EXCHANGE_RATE,
  GET_EXCHANGE_RATE,
  CLEAR_EXCHANGE_RATE,
} from '../types';
import { EXCHANGE_RATE_ENDPOINT } from '../../config/endpoints';
import {
  DEFAULT_DELETE_CONFIG,
  DEFAULT_GET_CONFIG,
  DEFAULT_POST_CONFIG,
  DEFAULT_PUT_CONFIG,
} from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import { EXCHANGE_RATE_PATH } from '../../config/paths';

const flagGettingExchangeRates = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_EXCHANGE_RATES,
    payload: flag,
  });

const getExchangeRates = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingExchangeRates(true));
    const query = tableFilters;
    const url = `${EXCHANGE_RATE_ENDPOINT}?${QueryString.stringify(query)}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const exchangeRates = await response.json();
    dispatch({
      type: GET_EXCHANGE_RATES,
      payload: exchangeRates,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGettingExchangeRates(false));
  }
};

const clearExchangeRates = () => (dispatch) =>
  dispatch({
    type: CLEAR_EXCHANGE_RATES,
  });

const flagGettingExchangeRate = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_EXCHANGE_RATE,
    payload: flag,
  });

const getExchangeRate =
  async ({ exchangeRateId }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingExchangeRate(true));
      const url = `${EXCHANGE_RATE_ENDPOINT}/${exchangeRateId}`;
      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });
      await isErrorResponse(response, null, dispatch);
      const exchangeRate = await response.json();
      dispatch({
        type: GET_EXCHANGE_RATE,
        payload: exchangeRate,
      });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingExchangeRate(false));
    }
  };

const clearExchangeRate = () => (dispatch) =>
  dispatch({
    type: CLEAR_EXCHANGE_RATE,
  });

const postExchangeRate =
  async ({ currency, rate }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingExchangeRate(true));
      const payload = {
        currency, rate
      };
      const url = EXCHANGE_RATE_ENDPOINT;
      const response = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(response, null, dispatch);
      const exchangeRate = await response.json();
      dispatch(push(`${EXCHANGE_RATE_PATH}/${exchangeRate.id}`));
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingExchangeRate(false));
    }
  };

const putExchangeRate =
  async (exchangeRateId, { currency, rate }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingExchangeRate(true));
      const payload = {
        id: exchangeRateId,
        currency, rate
      };
      const url = `${EXCHANGE_RATE_ENDPOINT}/${exchangeRateId}`;
      const response = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(response, null, dispatch);
      const exchangeRate = await response.json();
      dispatch(push(`${EXCHANGE_RATE_PATH}/${exchangeRate.id}`));
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingExchangeRate(false));
    }
  };

const deleteExchangeRate =
  async ({ exchangeRateId }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingExchangeRate(true));
      const url = `${EXCHANGE_RATE_ENDPOINT}/${exchangeRateId}`;
      const response = await fetch(url, {
        ...DEFAULT_DELETE_CONFIG,
      });
      await isErrorResponse(response, null, dispatch);
      await response;
      dispatch(push(EXCHANGE_RATE_PATH));
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingExchangeRate(false));
    }
  };

export {
  getExchangeRates,
  clearExchangeRates,
  getExchangeRate,
  postExchangeRate,
  putExchangeRate,
  clearExchangeRate,
  deleteExchangeRate,
};
